// extracted by mini-css-extract-plugin
export default {"wrapper":"ArticleDetailsView_wrapper__nhrYK"};